export const WC_TO_ARENA_BRIDGE_SNACKBAR = {
  TITLE: 'Nice pick! 🎯',
  ACTION_LABEL: 'Show me',
  DURATION_MS: 7000,
} as const;

export const getArenaBridgeSnackbarMessage = (): string =>
  'Try daily challenges & 1v1s on the Arena tab.';
